import { createSelectorPathBuilder } from '@/checkout-instore-legacy/utils/selectorHelper'

export const rootModalSelector = createSelectorPathBuilder(
  (state) => state.rootModal
)
